export default "__VITE_ASSET__53696a24__"